const COLOR_ORDERING = {
  'red': 1,
  'white': 2,
  'rose': 3
};


export const wineSort = (wines) => {
  wines.sort((a, b) => {
    if (a._producer_name && b._producer_name) {
      if (a._producer_name.toLowerCase() > b._producer_name.toLowerCase()) return 1;
      if (a._producer_name.toLowerCase() < b._producer_name.toLowerCase()) return -1;
    }

    if (a.color && b.color) {
      if (COLOR_ORDERING[a.color] > COLOR_ORDERING[b.color]) return 1;
      if (COLOR_ORDERING[a.color] < COLOR_ORDERING[b.color]) return -1;
    }

    if (a.region && b.region) {
      if (a.region.toLowerCase() > b.region.toLowerCase()) return 1;
      if (a.region.toLowerCase() < b.region.toLowerCase()) return -1;
    }

    if (a.name && b.name) {
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    }

    return 0;
  });
};
